export const SEARCH_API_CONSTANTS = {
  TAB_DATA: "tabList",
  SEARCH_RESULT :"searchResult",
  MORE_FILTERS: "seeMoreFilters",
  SEARCH_SUGGESTIONS: "getSuggestion",
  QUICK_INFO: 'getQuickInfo',
  SUBJECT_LIST: 'subjectList',
  DOC_INTRO: 'getDocInfo',
  PRODUCT_SEARCH_SUGGESTION: 'getSearchSuggestion',
  TOP_STORY_INFO: 'infoTopStory',
  ALERTS: 'alerts',
  UPDATE_ALERTS: 'updateAlert/',
  DOCUMENT_FOLLOW: 'document/follow/',
};

export const API_CONSTANTS = {
  USER_IP_ADDRESS: "auth/getclientipbydomain",
  GET_CATALOGUE: "home/getCatalogue",
  LOGOUT : "/auth/logout",
  GET_MACHINE_ID:"/machineId",
  GET_PRICING:"/pricing/premium",
  ADD_PRODUCT_TO_CART:"/cart/addProductsToUserCart",
  CHECK_EXISTING_SUBSCRIPTION:"/premium/checkExistingSubscription",
  FAQ:"support/faqs",
  SEO_DETAILS: "seoDetails",
  ENDMILE_EVENT_TRACK: "eventemileProcess",
  USER_SITE_TRACKING: "userSiteTracking",
  SEARCH_LOG: "search/log",
  NEW_ENDMILE_EVENT_TRACK: "newEventEndmileProcess",
};

